/**
 * `homewall` translations, for every locale -- the home page's top strip, its
 * moving wall, and the every-staff org chart.
 */
export const homewall = {
  mn: {
    homewall: {
      morning: 'Өглөөний мэнд, {{name}}',
      afternoon: 'Өдрийн мэнд, {{name}}',
      evening: 'Оройн мэнд, {{name}}',
      todayTitle: 'Өнөөдөр',
      timeLogged: 'Өнөөдрийн цаг: {{status}}',
      timeNotLogged: 'Өнөөдрийн цаг хараахан бүртгэгдээгүй',
      onLeaveToday: 'Та өнөөдөр чөлөөтэй: {{label}}',
      holidayToday: 'Өнөөдөр амралтын өдөр: {{label}}',
      nextDayOff: 'Дараагийн амралт: {{date}} — {{label}}',
      shiftToday: 'Өнөөдрийн ээлж: {{code}}',
      shiftNext: 'Дараагийн ээлж: {{date}} ({{code}})',
      shiftNone: 'Ойрын 30 хоногт ээлж алга',
      deskToday: 'Өнөөдрийн ширээ: {{desk}}',
      quickLinks: 'Түргэн холбоос',
      linkLogTime: 'Цаг бүртгэх',
      linkLeave: 'Чөлөө хүсэх',
      linkOrgChart: 'Байгууллагын бүтэц',
      linkDesk: 'Ширээ захиалах',
      treeLoadFailed: 'Ажилтны лавлахыг ачаалж чадсангүй, тиймээс схем хоосон байна: {{detail}}. Хуудсыг дахин ачаална уу.',
      statsLoadDetail: 'Сервер: {{detail}}. Хуудсыг дахин ачаална уу.',
      structureLoadFailed: 'Баг, бүтээгдэхүүнийг ачаалж чадсангүй: {{detail}}. Хуудсыг дахин ачаална уу.',
      slideOrgChart: 'Байгууллагын бүтэц',
      slideCompany: 'Компани өнөөдөр',
      slideFund: 'Үйл ажиллагааны сан',
      reports: '{{n}} хүн доор нь',
      openOrgChart: 'Бүтцийг нээх',
      nobodyOnLeave: 'Өнөөдөр хэн ч чөлөө аваагүй.',
      fundBalance: 'Сангийн үлдэгдэл',
      fundIncome: 'Энэ сарын орлого',
      fundExtra: 'Энэ сарын нэмэлт орлого',
      fundExpense: 'Энэ сарын зарлага',
      fundNet: 'Энэ сарын цэвэр',
      openFund: 'Санг нээх',
      orgTitle: 'Байгууллагын бүтэц',
      search: 'Ажилтан хайх',
      searchPlaceholder: 'Нэр, албан тушаал, баг',
      found: '{{n}} олдлоо',
      noMatch: 'Тохирох хүн алга',
      prevMatch: 'Өмнөх илэрц',
      nextMatch: 'Дараагийн илэрц',
      expandAll: 'Бүгдийг дэлгэх',
      collapseAll: 'Бүгдийг хураах',
      openProfile: 'Профайл нээх',
      filterToPerson: '{{name}}-ээр шүүх',
      expand: '{{name}}-г дэлгэх',
      collapse: '{{name}}-г хураах',
      directReports: 'шууд {{n}}',
      noTeam: 'Баггүй',
      whoIsIn: 'Өнөөдөр ажиллаж буй',
      ofPeople: '{{n}} хүнээс',
      noModesYet: 'Өнөөдөр ажлын горим бүртгэгдээгүй байна.',
      desksFree: 'Өнөөдөр сул ширээ',
      ofTotal: '{{total}}-аас {{n}}',
      desksFreeMeter: '{{total}} ширээнээс {{free}} сул',
      bookDesk: 'Ширээ захиалах',
      noOffice: 'Оффисгүй',
      hoursByWorkType: 'Ажлын төрлөөр цаг',
      byOffice: 'Оффисоор ажилтан',
      desksByWeekday: 'Гарагаар ширээний захиалга',
      desksByWeekdayHint: 'Дундаж, сүүлийн 90 хоног',
      topDesks: 'Хамгийн их захиалсан ширээ',
      last90: 'Сүүлийн 90 хоног',
      birthdaysThisMonth: 'Энэ сарын төрсөн өдрүүд',
      noBirthdaysThisMonth: 'Энэ сард төрсөн өдөр алга.',
      orgLoadFailed: 'Ажилтны лавлахыг ачаалж чадсангүй',
      companyLoadFailed: 'Компанийн үзүүлэлтийг ачаалж чадсангүй',
      fundLoadFailed: 'Сангийн дүнг ачаалж чадсангүй',
      birthdaysLoadFailed: 'Төрсөн өдрүүдийг ачаалж чадсангүй',
      spotlight: 'Онцлох',
      slidePage: '{{total}}-с {{n}}-р хуудас',
      slidePause: 'Гүйлгээг зогсоох',
      slidePlay: 'Гүйлгээг үргэлжлүүлэх',
      slidePrev: 'Өмнөх',
      slideNext: 'Дараах',
      chartsCarousel: 'Компанийн графикууд',
      awayToday: 'Өнөөдөр чөлөөтэй',
      awayNext14: 'Ирэх 14 хоногт чөлөөтэй',
      awayTrend: 'Ирэх 14 хоногт өдөр бүр чөлөөтэй хүн: {{list}}',
      awayHint: 'Ирэх 14 хоногт хамгийн ихдээ {{max}}',
      awayOn: '{{count}} хүн чөлөөтэй',
      weekdayCaption: 'Хамгийн их: {{peak}}. Хамгийн бага: {{trough}}.',
      peopleUnit: '1 нүд = 1 хүн',
      peopleShort: 'хүн',
      hoursShort: 'цаг',
    },
  },
  en: {
    homewall: {
      morning: 'Good morning, {{name}}',
      afternoon: 'Good afternoon, {{name}}',
      evening: 'Good evening, {{name}}',
      todayTitle: 'Today',
      timeLogged: "Today's time: {{status}}",
      timeNotLogged: "Today's time isn't logged yet",
      onLeaveToday: "You're off today: {{label}}",
      holidayToday: 'Today is a holiday: {{label}}',
      nextDayOff: 'Next day off: {{date}} — {{label}}',
      shiftToday: 'Roster today: {{code}}',
      shiftNext: 'Next roster shift: {{date}} ({{code}})',
      shiftNone: 'No roster shift in the next 30 days',
      deskToday: 'Desk today: {{desk}}',
      quickLinks: 'Quick links',
      linkLogTime: 'Log time',
      linkLeave: 'Request leave',
      linkOrgChart: 'Org chart',
      linkDesk: 'Book a desk',
      treeLoadFailed: 'Could not load the staff directory, so the chart is empty: {{detail}}. Reload the page to try again.',
      statsLoadDetail: 'The server said: {{detail}}. Reload the page to try again.',
      structureLoadFailed: 'Could not load teams and products: {{detail}}. Reload the page to try again.',
      slideOrgChart: 'Org chart',
      slideCompany: 'The company today',
      slideFund: 'Activity fund',
      reports: '{{n}} below',
      openOrgChart: 'Open the org chart',
      nobodyOnLeave: 'Nobody is on leave today.',
      fundBalance: 'Fund balance',
      fundIncome: 'In this month',
      fundExtra: 'Extra income this month',
      fundExpense: 'Spent this month',
      fundNet: 'Net this month',
      openFund: 'Open the fund',
      orgTitle: 'Org chart',
      search: 'Find a person',
      searchPlaceholder: 'Name, position or team',
      found: '{{n}} found',
      noMatch: 'Nobody matches',
      prevMatch: 'Previous match',
      nextMatch: 'Next match',
      expandAll: 'Expand all',
      collapseAll: 'Collapse all',
      openProfile: 'Open profile',
      filterToPerson: 'Show {{name}} and their people',
      expand: 'Expand {{name}}',
      collapse: 'Collapse {{name}}',
      directReports: '{{n}} direct',
      noTeam: 'No team',
      whoIsIn: "Who's in today",
      ofPeople: 'of {{n}} people',
      noModesYet: 'No work mode logged yet today.',
      desksFree: 'Desks free today',
      ofTotal: '{{n}} of {{total}}',
      desksFreeMeter: '{{free}} of {{total}} desks free',
      bookDesk: 'Book a desk',
      noOffice: 'No office',
      hoursByWorkType: 'Hours by work type',
      byOffice: 'Staff by office',
      desksByWeekday: 'Desk bookings by weekday',
      desksByWeekdayHint: 'Average, last 90 days',
      topDesks: 'Most-booked desks',
      last90: 'Last 90 days',
      birthdaysThisMonth: 'Birthdays this month',
      noBirthdaysThisMonth: 'No birthdays this month.',
      orgLoadFailed: "The staff directory didn't load",
      companyLoadFailed: "The company figures didn't load",
      fundLoadFailed: "The activity fund totals didn't load",
      birthdaysLoadFailed: "This month's birthdays didn't load",
      spotlight: 'Highlights',
      slidePage: 'Page {{n}} of {{total}}',
      slidePause: 'Pause the slides',
      slidePlay: 'Play the slides',
      slidePrev: 'Previous',
      slideNext: 'Next',
      chartsCarousel: 'Company charts',
      awayToday: 'Away today',
      awayNext14: 'Away over the next 14 days',
      awayTrend: 'People away each day for the next 14 days: {{list}}',
      awayHint: 'Up to {{max}} in the next 14 days',
      awayOn: '{{count}} away',
      weekdayCaption: 'Busiest: {{peak}}. Quietest: {{trough}}.',
      peopleUnit: '1 square = 1 person',
      peopleShort: 'people',
      hoursShort: 'hours',
    },
  },
  ru: {
    homewall: {
      morning: 'Доброе утро, {{name}}',
      afternoon: 'Добрый день, {{name}}',
      evening: 'Добрый вечер, {{name}}',
      todayTitle: 'Сегодня',
      timeLogged: 'Время за сегодня: {{status}}',
      timeNotLogged: 'Время за сегодня ещё не внесено',
      onLeaveToday: 'Сегодня вы не работаете: {{label}}',
      holidayToday: 'Сегодня праздник: {{label}}',
      nextDayOff: 'Следующий выходной: {{date}} — {{label}}',
      shiftToday: 'Смена сегодня: {{code}}',
      shiftNext: 'Следующая смена: {{date}} ({{code}})',
      shiftNone: 'Смен в ближайшие 30 дней нет',
      deskToday: 'Стол сегодня: {{desk}}',
      quickLinks: 'Быстрые ссылки',
      linkLogTime: 'Внести время',
      linkLeave: 'Подать заявку на отпуск',
      linkOrgChart: 'Оргструктура',
      linkDesk: 'Забронировать стол',
      treeLoadFailed: 'Не удалось загрузить справочник сотрудников, поэтому схема пуста: {{detail}}. Перезагрузите страницу.',
      statsLoadDetail: 'Ответ сервера: {{detail}}. Перезагрузите страницу.',
      structureLoadFailed: 'Не удалось загрузить команды и продукты: {{detail}}. Перезагрузите страницу.',
      slideOrgChart: 'Оргструктура',
      slideCompany: 'Компания сегодня',
      slideFund: 'Фонд мероприятий',
      reports: 'В подчинении: {{n}}',
      openOrgChart: 'Открыть оргструктуру',
      nobodyOnLeave: 'Сегодня никто не в отпуске.',
      fundBalance: 'Остаток фонда',
      fundIncome: 'Поступило в этом месяце',
      fundExtra: 'Доп. доход в этом месяце',
      fundExpense: 'Потрачено в этом месяце',
      fundNet: 'Итог месяца',
      openFund: 'Открыть фонд',
      orgTitle: 'Оргструктура',
      search: 'Найти сотрудника',
      searchPlaceholder: 'Имя, должность или команда',
      found: 'Найдено: {{n}}',
      noMatch: 'Никого не найдено',
      prevMatch: 'Предыдущее совпадение',
      nextMatch: 'Следующее совпадение',
      expandAll: 'Развернуть всё',
      collapseAll: 'Свернуть всё',
      openProfile: 'Открыть профиль',
      filterToPerson: 'Показать {{name}} и их людей',
      expand: 'Развернуть: {{name}}',
      collapse: 'Свернуть: {{name}}',
      directReports: 'прямых: {{n}}',
      noTeam: 'Без команды',
      whoIsIn: 'Кто сегодня на работе',
      ofPeople: 'из {{n}} человек',
      noModesYet: 'Сегодня режим работы ещё не отмечен.',
      desksFree: 'Свободные столы сегодня',
      ofTotal: '{{n}} из {{total}}',
      desksFreeMeter: 'Свободно {{free}} из {{total}} столов',
      bookDesk: 'Забронировать стол',
      noOffice: 'Без офиса',
      hoursByWorkType: 'Часы по типу занятости',
      byOffice: 'Сотрудники по офисам',
      desksByWeekday: 'Бронирования столов по дням недели',
      desksByWeekdayHint: 'В среднем, последние 90 дней',
      topDesks: 'Самые популярные столы',
      last90: 'Последние 90 дней',
      birthdaysThisMonth: 'Дни рождения в этом месяце',
      noBirthdaysThisMonth: 'В этом месяце дней рождения нет.',
      orgLoadFailed: 'Не удалось загрузить справочник сотрудников',
      companyLoadFailed: 'Не удалось загрузить показатели компании',
      fundLoadFailed: 'Не удалось загрузить итоги фонда',
      birthdaysLoadFailed: 'Не удалось загрузить дни рождения',
      spotlight: 'Главное',
      slidePage: 'Страница {{n}} из {{total}}',
      slidePause: 'Остановить показ',
      slidePlay: 'Продолжить показ',
      slidePrev: 'Назад',
      slideNext: 'Вперёд',
      chartsCarousel: 'Графики компании',
      awayToday: 'Отсутствуют сегодня',
      awayNext14: 'Отсутствуют в ближайшие 14 дней',
      awayTrend: 'Отсутствуют по дням в ближайшие 14 дней: {{list}}',
      awayHint: 'До {{max}} в ближайшие 14 дней',
      awayOn: 'отсутствуют: {{count}}',
      weekdayCaption: 'Больше всего: {{peak}}. Меньше всего: {{trough}}.',
      peopleUnit: '1 клетка = 1 человек',
      peopleShort: 'чел.',
      hoursShort: 'ч',
    },
  },
}
